import React from "react";
import PropTypes from "prop-types";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";


export const ConsentToggleButtonProps = PropTypes.shape({
  value: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
});

export default function ConsentToggleButton({ handleChange, value = null }) {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
      <ToggleButtonGroup
        size="small"
        aria-label="Small sizes"
        value={value}
        onChange={handleChange}
        exclusive
        aria-describedby="consent-description"
      >
        <ToggleButton selected={value} value={value} sx={{ width: "150px" }}>
          {t("common:opposition")}
        </ToggleButton>
        <ToggleButton selected={!value} value={!value} sx={{ width: "150px" }}>
          {t("common:noOpposition")}
        </ToggleButton>
      </ToggleButtonGroup>
      {value === true && (
        <Typography variant="body2" id="consent-description">
          {t("common:oppositionConfirmation")}
        </Typography>
      )}
      {value === false && (
        <Typography variant="body2" id="consent-description">
          {t("common:noOppositionConfirmation")}
        </Typography>
      )} 
    </Box>
  );
}

ConsentToggleButton.propTypes = { ...ConsentToggleButtonProps };
